<template>
    <nav class="top-navbar">
        <div class="top-navbar-item">
            <router-link class="logo" :to="{name: 'blog'}">
                <!-- <h1>Blog <strong>Jurídico</strong></h1> -->
                <img src="@/assets/img/svg/dike_logo.png" width="150" alt="Crivelli - Diké" title="Crivelli - Dikè">
            </router-link>
        </div>
        <div class="flex-1"></div>
        <div class="top-navbar-item hidden-mobile">
            <social-networks :icon-width="19" />
        </div>
        <div class="top-navbar-item search-container">
            <div class="input" :class="{collapsed: !inputSearchOpen}">
                <input  type="text" placeholder="Digite sua busca">
                <a class="control" @click="() => inputSearchOpen = !inputSearchOpen">
                    <svg height="15" viewBox="0 0 18.666 18.666">
                        <path d="M8.22 0C3.69 0 0 3.689 0 8.22c0 4.534 3.689 8.221 8.22 8.221a8.183 8.183 0 005.25-1.898l3.901 3.9a.757.757 0 101.072-1.072l-3.9-3.9a8.183 8.183 0 001.898-5.25C16.441 3.689 12.754 0 8.221 0zm0 1.518a6.71 6.71 0 016.702 6.703 6.708 6.708 0 01-6.701 6.7 6.71 6.71 0 01-6.703-6.7A6.71 6.71 0 018.22 1.518z"/>
                    </svg>
                </a>
            </div>
        </div>
        <div class="top-navbar-item hidden-mobile">
            <router-link :to="{name: 'home'}" class="button button-orange is-transparent is-outlined is-small">
                Conheça o Escritório
            </router-link>
        </div>
        <div class="top-navbar-item tel">
            <label class="hidden-mobile">Precisa de Ajuda?</label>
            <a href="tel:1133760110">
                <img src="@/assets/img/svg/whatsapp.svg" width="30">
                <small class="hidden-mobile">(11)</small><span class="hidden-mobile">3376-0100</span>
            </a>
        </div>
        <div class="top-navbar-item">
            <a class="menu-control" @click="toggleMenu">
                <img src="@/assets/img/svg/close.svg" width="45" v-if="menuOpened">
                <template v-else><span class="hidden-mobile">Menu</span><img src="@/assets/img/svg/menu.svg" width="50"> </template>
            </a>
        </div>
    </nav>
</template>

<script>
import SocialNetworks from "@/components/SocialNetworks";
export default {

    components: {
        SocialNetworks
    },
    props: {
        menuOpened: Boolean,
    },

    data() {
        return {
            inputSearchOpen: false,
        }
    },

    methods: {
        toggleMenu() {
            this.$emit('update:menuOpened', !this.menuOpened);
        }
    }
}
</script>

<style>

</style>
